import { Mui } from "@osu/react-ui";

const styles = {
  nestedChip: (theme) => ({
    maxHeight: "25px",
    color: "black",
    marginLeft: theme.spacing(1),
    "&.MuiChip-root": {
      backgroundColor: "white",
    },
  }),
  parentChip: (theme) => ({
    minHeight: "38px",
    margin: theme.spacing(1),
  }),
};

const Chip = (props) => {
  const {label, childLabel} = props;
  return ( 
    <Mui.Chip
              component="div"
              sx={styles.parentChip}
              label={
                <Mui.Typography component="span" style={{fontSize: "15px"}}>
                  {label}
                  <Mui.Chip
                    component="span"
                    sx={styles.nestedChip}
                    label={childLabel}
                  />
                </Mui.Typography>
              }
            />
  );
};
export default Chip;
